import { useState } from "react"
import { useLocation } from "react-router-dom"
import { SidebarItem } from "@/features/sidebar/ui/sidebar-item.tsx"
import { Collapse } from "@/shared/components"
import type { CustomRoute } from "@/shared/types"

interface IProps {
  items: CustomRoute[]
  item: CustomRoute
  depth?: number
  open: boolean
  onOpen: VoidFunction
  path?: string
  allOpen?: boolean
}

export const SidebarItems = ({ items, item, depth = 0, open, onOpen, path, allOpen }: IProps) => {
  // Helpers
  const location = useLocation()

  // States
  const [inOpen, setInOpen] = useState<string>()

  // Functions
  const isActiveParent = path ? location.pathname.includes(path) : false

  return (
    <div>
      <SidebarItem
        className="ml-2 rounded-lg ring-blue-400 transition focus:outline-none focus:ring-2"
        isActiveParent={isActiveParent}
        item={item}
        onClick={onOpen}
        withChild={items.length > 0 && item.handle?.ignoreChildren !== true}
        depth={depth}
        tabIndex={0}
      />
      {item.handle?.ignoreChildren !== true && (
        <Collapse in={allOpen != null ? allOpen : open}>
          <div className="mt-1 mb-2 flex flex-col gap-1">
            {items.map((childItem, index) => {
              if (childItem.children != null && childItem.handle?.ignoreChildren !== true) {
                return (
                  <SidebarItems
                    onOpen={() => setInOpen(old => (old === inOpen ? "" : childItem.path))}
                    open={allOpen != null ? allOpen : inOpen === childItem.path}
                    key={index}
                    item={childItem}
                    items={childItem.children}
                    depth={depth + 1}
                    path={`${path}/${childItem.path}`}
                  />
                )
              }
              return (
                <SidebarItem
                  className="mr-1 ml-6 h-9 rounded-lg"
                  path={`${path}/${childItem.path}`}
                  isActiveParent={childItem.path ? location.pathname.includes(childItem.path) : false}
                  item={childItem}
                  key={index}
                  withChild={childItem.children != null && childItem.handle?.ignoreChildren !== true}
                  depth={depth + 1}
                />
              )
            })}
          </div>
        </Collapse>
      )}
    </div>
  )
}
